<div class="b-validation__issue" [style.display]="!summary && !details ? 'none' : ''">
  <span class="b-validation__issue-status"></span>
  <span class="b-validation__issue-text" [style.display]="!summary ? 'none' : ''">
    <span class="b-validation__issue-text-cell" [innerHTML]="summary"></span>
  </span>
  <span class="b-validation__issue-text" [style.display]="!details ? 'none' : ''">
    <span class="b-validation__issue-text-cell" [innerHTML]="details"></span>
  </span>
</div>